import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
    hidden: { opacity: 0, y: 28 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.75, ease: EASE } },
};

export function Reveal({ children, className = "", delay = 0, testid }) {
    return (
        <motion.div
            data-testid={testid}
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
            variants={fadeUp}
            transition={{ delay }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0 }) {
    return (
        <span className={className}>
            {lines.map((l, i) => (
                <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        initial={{ y: "112%" }}
                        animate={{ y: "0%" }}
                        transition={{ delay: delay + i * 0.15, duration: 0.95, ease: EASE }}
                    >
                        {l}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}

export function spotlight(e) {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
}

export default Reveal;